import React from 'react'
import clsx from 'clsx'
import { ls } from '../../../locale'
import {plus} from 'react-icons-kit/icomoon/plus'
import { Icon } from 'react-icons-kit'
import { PassengerBox, SelectedService } from "./PassengerBox";
import { Passenger } from "../../../state/models";
import { Ancillary } from "../../../state/models/Ancillary";

type CarryOnBagsProps = {
  passengers: Passenger[];
  ancillaries: Ancillary[];
  currencyCode: string;
  onSelectService: (service: SelectedService) => void;
  onClearService: (service: SelectedService) => void;
};

export default function CarryOnBags({passengers, ancillaries, currencyCode, onSelectService, onClearService}: CarryOnBagsProps) {

  if(!Array.isArray(passengers)) return null;
  if(!Array.isArray(ancillaries)) return null;
  if(!ancillaries.some(a => Array.isArray(a.passengers) && a.passengers.some(p => Array.isArray(p.carryOnBags) && p.carryOnBags.length > 0))) return null;

  return (
    <div className='tw-mt-4 tw-mb-10'>
      <div className='tw-shadow-outline-gray tw-mt-5 tw-bg-white'>
        <Header />
        <Description />
        <div className='tw-flex tw-flex-col tw-gap-0'>
          {passengers.map((passenger, index) => {
            return (
              <PassengerBox key={index}
                serviceKey='carryOnBags'
                passenger={passenger}
                ancillaries={ancillaries}
                currencyCode={currencyCode}
                onSelectService={onSelectService}
                onClearService={onClearService}
              />)
          })}
        </div>
      </div>
    </div>
  )
}

function Header() {
  return (
    <div className='tw-px-4 tw-pt-4 tw-flex tw-justify-between'>
      <div className='tw-text-lg sa-text-green tw-uppercase'>Add more carry-on baggage</div>
    </div>
  )
}

function Description() {

  const rExtraPage = ls.t('ExtraPage');

  let terms = rExtraPage.CarryOnBags.Terms;
  if(typeof terms === 'string') terms = terms.split(/[\r\n]/);

  let specs = rExtraPage.CarryOnBags.Specs;
  if(typeof specs === 'string') specs = specs.split(/[\r\n]/);

  return (
    <div className={clsx('tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-px-4 tw-pb-1'
      ,'tw-flex tw-flex-col tw-gap-3 md:tw-flex-row md:tw-justify-center'
    )}>
      <div className='tw-flex tw-justify-start md:tw-justify-center md:tw-items-center sa-text-green'>
        <div className='tw-grid tw-grid-rows-[64px_20px] tw-grid-cols-5 tw-gap-y-0 tw-gap-x-2 tw-max-w-md tw-place-items-center'>
            <img src='/images/icon-handbag.png' alt='handbag' className='tw-size-16' />
            <div className='tw-text-xl tw-font-bold'>5KG</div>
            <Icon size={20} icon={plus} />
            <img src='/images/icon-carryon.png' alt='carry on baggage' className='tw-size-16' />
            <div className='tw-text-xl tw-font-bold'>10KG</div>
            <div className='tw-font-bold'>Small bag</div>
            <div className='tw-text-[7px] sa-bg-yellow sa-text-blue tw-py-[2px] tw-px-2 tw-rounded-full'>INCLUDED</div>
            <div></div>
            <div className='tw-font-bold'>Trolly bag</div>
            <div></div>
        </div>
      </div>
      <div className='tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2'>
        <img src='/images/priority.png' alt='priority' className='tw-h-28' />
        <div>
          { specs.map((spec: string, index: number) => <div key={index}>{spec}</div>) }
        </div>
      </div>
    </div>
  )
}
